class Ideal {
    constructor() {
        $('#serviceForm > button.pay-by-ideal').on('click', function () {
            let form = $('<form></form>');
            form.attr('method', 'post');
            form.attr('action', '/?action=paymentmethod/ideal');

            form.append(Ideal.createHiddenInput('issuer', $(this).closest('li').data('id')));
            form.append(Ideal.createHiddenInput('ordernumber', $('#orderid').val()));

            $(document.body).append(form);
            form.submit();
        });
    }

    static createHiddenInput(name, value) {
        let $input = $('<input/>');
        $input.attr('name', name);
        $input.attr('value', value);
        return $input;
    }
}


$(document).ready(function () {
    new Ideal();
});